import { Component, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from './service/api.service';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NgxSpinnerService } from "ngx-spinner";
import { NzModalModule } from 'ng-zorro-antd/modal';
import { DomSanitizer } from '@angular/platform-browser';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'UTO';
  validateForm: FormGroup;
  videos: any[];
  isVisible = false;
  videoId;
  loading = false;
  @ViewChild(TemplateRef, { static: false }) template: TemplateRef<{}>;
  ngOnInit(): void {
  }

  constructor(private spinner: NgxSpinnerService, private service: ApiService, private _sanitizer: DomSanitizer, private notificationService: NzNotificationService) { };
  submit(event: any) {
    this.videos = [];
    let searchKey: any = event.target.value;
    this.loading = true;
    this.service.getSearchVideobyKeyWord<any[]>(searchKey).subscribe((data: any[]) => {
      for (let element of data['items']) {
        this.videos.push(element);
        this.loading = false;
      }
      this.notificationService.template(this.template, { nzData: data['pageInfo'] });
      console.log(data);
    });
  }

  // modal code here
  showModal(event): void {
    this.videoId = this._sanitizer.bypassSecurityTrustResourceUrl(
      'https://www.youtube.com/embed/' + event.videoId
    );
    console.log(this.videoId);
    this.isVisible = true;
  }

  handleOk(): void {
    console.log('Button ok clicked!');
    this.isVisible = false;
  }
  handleCancel(): void {
    console.log('Button cancel clicked!');
    this.isVisible = false;
  }
}
